import { VerticalStack } from '@/components/utils/linearLayouts';

import { LeftRailBandIdentity, LeftRailHeaderBand } from './PatientLeftRail.layout';

// The rail before its query returns: the band it always has, holding its height on the same two
// lines of type the band fills in, and nothing else.
export const PatientLeftRailSkeleton = () => (
    <VerticalStack>
        <LeftRailHeaderBand>
            <LeftRailBandIdentity />
        </LeftRailHeaderBand>
    </VerticalStack>
);
